export default __webpack_public_path__ + "e85a1b32b7cefe507f40194438240782.svg";